import { render, staticRenderFns } from "./ChecklistForm.vue?vue&type=template&id=3bf9aca6&scoped=true&"
import script from "./ChecklistForm.vue?vue&type=script&lang=js&"
export * from "./ChecklistForm.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistForm.vue?vue&type=style&index=0&id=3bf9aca6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf9aca6",
  null
  
)

export default component.exports